export default "__VITE_ASSET__CaCM3roR__"